exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".screenContainer {\n  background-color: #37474f;\n  height: 100vh; }\n\n.pageNameDisplay {\n  font-size: 40px;\n  color: white;\n  position: absolute;\n  right: 10px;\n  bottom: 16px;\n  background-color: black;\n  border: 1px solid white;\n  padding: 10px;\n  border-radius: 25px; }\n\n.setupButtonDisplay {\n  opacity: 0;\n  font-size: 40px;\n  color: white;\n  position: absolute;\n  left: 10px;\n  bottom: 16px;\n  background-color: black;\n  border: 1px solid white;\n  padding: 10px;\n  border-radius: 25px;\n  cursor: pointer; }\n\n.setupButtonDisplay:hover {\n  opacity: 1; }\n\n.visible {\n  visibility: visible;\n  opacity: 1;\n  transition: opacity 1s linear; }\n\n.hidden {\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s 2s, opacity 2s linear; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/Screen.scss
// module id = 321
// module chunks = 0